module.exports = __webpack_public_path__ + "img/comments-solid updated.b5511d98.svg";